import { DestinationUrlValue } from '../elements/Fields'

/**
 * Hides historical ad destinations whose publisher left the current catalog.
 *
 * `catalogLoaded` is false while `configurationLoading` is true, and also
 * before the request has written `data`. An empty `destinations` array after
 * load is a real catalog: those publisher ids are gone, so their rows drop.
 * Rows without `publisher_id` are an existing shape and stay.
 */
export const filterDestinationUrlsByCatalog = (
  destinationUrls: DestinationUrlValue[],
  destinations: DestinationUrlsConfig[] | undefined,
  catalogLoaded: boolean
) => {
  if (!catalogLoaded) return destinationUrls

  const publisherIds = new Set(
    (destinations ?? [])
      .map(destination => destination.publisher_id)
      .filter((publisherId): publisherId is string => !!publisherId)
  )

  return destinationUrls.filter(
    destination =>
      !destination.publisher_id || publisherIds.has(destination.publisher_id)
  )
}
